module.exports = __webpack_public_path__ + "6ecf3ae876b5882fd173637add634ad1.png";